import { Typography } from '@mui/material';

type SmallIconProps = {
  title: string;
};

function SmallIcon({ title }: SmallIconProps) {
  return (
    <Typography variant="h2" sx={{ style: 'bold' }}>
      {title?.substring(0, 1).toUpperCase()}
    </Typography>
  );
}

export { SmallIcon };
export type { SmallIconProps };
